import validator from "validator";
import message from "../../../messages/page";

const validateTitle = (title) => {
  if (validator.isEmpty(title)) {
    return message.TITLE_DOSE_NOT_EXIST;
  }

  if (!title.trim().length) {
    return message.TITLE_DOSE_NOT_EXIST;
  }

  return true;
};

const validatePattern = (pattern) => {
  if (validator.isEmpty(pattern)) {
    return message.PATTERN_DOSE_NOT_EXIST;
  }

  if (!pattern.trim().length) {
    return message.PATTERN_DOSE_NOT_EXIST;
  }

  return true;
};

const validateActive = (active) => {
  if (validator.isNumeric(active)) {
    return message.ACTIVE_INVALID;
  }

  return true;
};

const validateLink = (link) => {
  if (validator.isEmpty(link)) {
    return message.LINK_DOSE_NOT_EXIST;
  }

  if (!link.trim().length) {
    return message.LINK_DOSE_NOT_EXIST;
  }

  if (!validator.isURL(link)) {
    return message.LINK_INVALID;
  }

  return true;
};

const validateFormAddPage = (info) => {
  const resValidateTitle = validateTitle(info.title);
  if (resValidateTitle != true) {
    return resValidateTitle;
  }

  const resValidatePattern = validatePattern(info.pattern);
  if (resValidatePattern != true) {
    return resValidatePattern;
  }

  const resValidateActive = validateActive(info.active + "");
  if (resValidateActive != true) {
    return resValidateActive;
  }

  const resValidateLink = validateLink(info.link);
  if (resValidateLink != true) {
    return resValidateLink;
  }

  return true;
};

export default validateFormAddPage;
